// extracted by mini-css-extract-plugin
export var Footer = "footer-module--Footer--RLqNu";
export var InnerFooter = "footer-module--InnerFooter--1u8tP";
export var QuickLinks = "footer-module--QuickLinks--1vdqU";
export var QuickItems = "footer-module--QuickItems--2nO78";
export var OuterFooter = "footer-module--OuterFooter--2RlAt";
export var WavesOpaque = "footer-module--WavesOpaque--2vsOV";
export var ShapeFill = "footer-module--ShapeFill--17Pq-";